// Vars //
var $body = jQuery('body');

// /* Hide Menu on Browser Resize */
function mobileMenuResizer() {
    $body.find('.js-mobile-trigger').removeClass('active');
    $body.removeClass('hamburger-menu-active');
    $body.removeClass('no-scroll');
}

// Change Navigation on scroll
function navOnScroll() {
    var $body = jQuery("body");
    var $navigation = $body.find('header.primary-navigation');
    var $screenTop = jQuery(document).scrollTop();

    /**
     * Add Class to body
     * Fix page refresh issue.
     */
    if ($screenTop >= 100) {
        $body.addClass("scrolled");
        $navigation.addClass("fixed");
    } else {
        $body.removeClass("scrolled");
        $navigation.removeClass("fixed");
    }

    /**
     * Add Class to body
     * on page scroll to alter navigation
     */
    jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();
        if (scroll >= 100) {
            $body.addClass("scrolled");
            $navigation.addClass("fixed");
        } else {
            $body.removeClass("scrolled");
            $navigation.removeClass("fixed");
        }
    });

}

// Header Slider - Setup Function
function sliderSetup() {
    jQuery('.slider-container.slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = false
            ;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            centerMode: false,
            variableWidth: true,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Product Slider
 * Used for multiple blocks - Feature Product Slider, Feature Category Product Slider
 * 
 */
function featureProductSliderSetup() {
    jQuery('.feature-product-slider-container .slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.feature-product-slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = false,
            slidesToShow, slidesToScroll;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 1600) {
            slidesToShow = 4;
            slidesToScroll = 1;
        } else if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
            slidesToScroll = 1;
        } else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
            slidesToScroll = 1;
            centerMode = true;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            slidesToScroll = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Content Block Slider
 * 
 */
function contentBlockSliderSetup() {
    jQuery('.slider-content-block.slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.slider-content-block');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = false
            ;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Logo Slider Block - sc-logo-slider-block.twig
 * 
 */
function logoSliderBlockSetup() {
    jQuery('.logo-slider-container .slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.logo-slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = false,
            slidesToShow, slidesToScroll;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        if (jQuery(window).width() > 1600) {
            slidesToShow = 4;
            slidesToScroll = 4;
        } else if (jQuery(window).width() > 1200) {
            slidesToShow = 3;
            slidesToScroll = 3;
        } else if (jQuery(window).width() > 767) {
            slidesToShow = 2;
            slidesToScroll = 2;
            centerMode = true;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            slidesToScroll = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}

// Inner Slider Block - Setup Function
function innerSliderBlockSliderSetup() {
    jQuery('.inner-slider-block-container.slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.inner-slider-block-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            dots = false,
            infinite = false
            ;

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }

        $slider.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}

// Latest News Gutenberg Block
function latestNewsSlider() {
    jQuery('.latest-news-container .slick-initialized').slick('unslick');
    var $sliderContainer = jQuery('.latest-news-container');
    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = true,
            slidesToShow = 1, slidesToScroll = 1;

        console.log(jQuery(window).width());

        if (jQuery(window).width() >= 1200) {
            slidesToShow = 4;
        } else if (jQuery(window).width() >= 1200 && jQuery(window).width() <= 1599) {
            slidesToShow = 3;
        } else if (jQuery(window).width() >= 767 && jQuery(window).width() <= 1159) {
            slidesToShow = 2;
            centerMode = true;
        } else if (jQuery(window).width() <= 766 ) {
            slidesToShow = 1;
            centerMode = true;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            arrows: false,
            variableWidth: true,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}

/**
 * 
 * Single: News Item
 * News Single Slider
 * 
 */
function singleNewsSliderSetup() {
    jQuery('.news-single-slider-container .slick-initialized').slick('unslick');

    var $sliderContainer = jQuery('.news-single-slider-container');

    $sliderContainer.each(function () {
        var $container = jQuery(this),
            $slider = $container.find('.slider'),
            $controls = $container.find('.slider-controls'),
            $dots = $container.find('.slider-dots'),
            centerMode = false,
            dots = false,
            infinite = false,
            slidesToShow, slidesToScroll;

        // Dots //
        if ($container.hasClass('dots')) {
            dots = true;
        }

        // Infinite //
        if ($container.hasClass('infinite')) {
            infinite = true;
        }
        
        if (jQuery(window).width() > 767) {
            slidesToShow = 2;
            slidesToScroll = 1;
        } else if (jQuery(window).width() < 480) {
            slidesToShow = 1;
            slidesToScroll = 1;
        }

        $slider.not('.slick-initialized').slick({
            centerMode: centerMode,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            dots: dots,
            infinite: infinite,
            appendDots: $dots,
            appendArrows: $controls,
            prevArrow:
                '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
            nextArrow:
                '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
        });
    });
}